import React from 'react';
import Interweave from 'interweave';

import { Box, Button, Typography } from '@mui/material';

import BlockFactory from './BlockFactory';
import BlockEditHeader from './BlockEditHeader';
import BlockEditFooter from './BlockEditFooter';

import ColorPallet from './ColorPallet';
import ScaleBar from './ScaleBar';
import NoImageIcon from 'icons/drawable/ic_img_empty.svg';

function ImageBlockEditView({idx, iconChar, iconColor, block, onUpdate, onDelete, onDone, onCancel}) {

	const imageAreaSize = React.useRef({ width: 0, height: 0 });

	const [data,setData] = React.useState(block.data ? block.data : '');
	const [resources,setResources] = React.useState(block.resources);

	const [uploadProgress,setUploadProgress] = React.useState(-1);

	const [optionMode,setOptionMode] = React.useState();
	const [backgroundColor,setBackgroundColor] = React.useState(block.backgroundColor);
	const [scale,setScale] = React.useState(block.scale === undefined ? 1 : block.scale);
	const [translationX,setTranslationX] = React.useState(block.translationX === undefined ? 0 : block.translationX);

	function getImageAreaName() {
		return 'image-area-' + block.name;
	}

	function getSelectImageInputName() {
		return 'select-image-' + block.name;
	}

	React.useEffect(() => {
		let imageArea = document.getElementById(getImageAreaName());
		if (imageArea) {
			console.log("imageAreaWidth = " + imageArea.clientWidth +
				", imageAreaHeight = " + imageArea.clientHeight);

			imageAreaSize.current = {
				width: imageArea.clientWidth,
				height: imageArea.clientHeight
			}
		}
	});

	const getUpdatedBlock = (b, s, t, d, r) => {
		let updatedBlock = BlockFactory.clone(block);
		updatedBlock.backgroundColor = b;
		updatedBlock.scale = s;
		updatedBlock.translationX = t;
		updatedBlock.data = d;
		updatedBlock.resources = r;
		return updatedBlock;
	};

	const handleImageSelect = async (e) => {
		let f = e.target.files[0];

		if (!f) return;

		if (!f.type.startsWith('image/')) {
			alert("이미지 파일이 아닙니다.\n이미지 파일을 선택해 주세요.");
			return;
		}

		if (f) {
			const RESOLUTION_LIMIT = 600;

			setUploadProgress(0);
			let uploadResult = await global.dipClient.uploadFile('image', f, RESOLUTION_LIMIT,
				(p) => { setUploadProgress(p); });

			setUploadProgress(1);

			if	(uploadResult && uploadResult.url) {
				// It seems Interweave always adds small padding to the bottom, margin-bottom of -5px here
				// is to fix it.
				//
				handleImageChange(
					`<img src="${uploadResult.url}" style="top:0;left:0;width:100%;margin-bottom:-5px;object-fit:contain;" alt="image block"/>`,
					[ uploadResult.resourceId ]
				);
/*
				handleImageChange(
					`<div style="position:fixed;top:0;left:0;width:100%;height:100%;background-image:url(${url});background-repeat:no-repeat;background-position:center center;-webkit-background-size:cover;background-size:cover;"/>`
				);
*/
			}
			setUploadProgress(-1);
		}
	};

	const handleBackgroundColorChange = (v) => {
		let newBackgroundColor = v;
		setBackgroundColor(newBackgroundColor);
		if (onUpdate) {
			onUpdate(getUpdatedBlock(newBackgroundColor, scale, translationX, data, resources));
		}
	};

	const handleScaleChange = (v) => {
		let newScale = v / 100;
		setScale(newScale);
		if (onUpdate) {
			onUpdate(getUpdatedBlock(backgroundColor, newScale, translationX, data, resources));
		}
	};

	const handleTranslationXChange = (v) => {
		let newTranslationX = (v - 50) * 2;
		setTranslationX(newTranslationX);
		if (onUpdate) {
			onUpdate(getUpdatedBlock(backgroundColor, scale, newTranslationX, data, resources));
		}
	};

	const handleImageChange = (newData, newResources) => {
		setData(newData);
		if (onUpdate) {
			onUpdate(getUpdatedBlock(backgroundColor, scale, translationX, newData, newResources));
		}
	};

	const handleDelete = () => {
		if (onDelete) {
			onDelete(block);
		}
	};

	const handleDone = () => {
		if (onDone) {
			onDone(getUpdatedBlock(backgroundColor, scale, translationX, data, resources));
		}
	};

	const handleCancel = () => {
		if (onCancel) {
			onCancel(block);
		}
	};

	const getImageArea = () => {
		if (uploadProgress !== -1) {
			return (
				<Box
					id={getImageAreaName()}
					display='flex'
					justifyContent='center'
					alignItems='center'
					sx={{
						width: '100%',
						height: `${140/360 * 100}vw`,
						backgroundColor:'black'
					}}
				>
					<Box
						display='flex'
						flexDirection='column'
						alignItems='center'
					>
						<Typography variant="body1" color="textSecondary">
							{'Uploading'}
						</Typography>
						<Typography variant="body2" color="textSecondary">
							{`${Math.round(uploadProgress * 100)}%`}
						</Typography>
					</Box>
				</Box>
			);
		}

		if (!data) {
			return (
				<div
					id={getImageAreaName()}
					style={{
						width: '100%',
						height: `${140/360 * 100}vw`,
						borderRadius: `${5.6/360 * 100}vw`,
						backgroundColor: '#f2f2f2',
						display: 'flex',
						flexDirection: 'column',
						justifyContent: 'center',
						alignItems: 'center',
					}}
				>
					<img src={NoImageIcon} alt="not uploaded icon"/>
					<Typography
						fontFamily='노토산스 Regular'
						fontSize={`${14/360 * 100}vw`}
						color='#aeaeae'
						sx={{
							marginTop: `${10/360 * 100}vw`
						}}
					>
						이미지를 업로드하세요
					</Typography>
				</div>
			);
		}

		const style = {
			width: '100%',
			transform: `translateX(${translationX}%) scale(${scale})`,
		};

		return (
			<div
				id={getImageAreaName()}
				style={{
					width:'100%',
					//border:'2px solid red',
					backgroundColor: backgroundColor,
					overflow: 'hidden',
					marginBottom:20,
				}}
			>
				<div id={block.name} style={style}>
					<Interweave content={data} />
				</div>
			</div>
		);
	}

	const getButtons = () => {
		const btnFontSize = 14;
		const btnTextMargin = -10;

		return (
			<Box
				display='flex'
				flexDirection='row'
				justifyContent='center'
				alignItems='center'
				sx={{
					width:'100%',
					marginTop: `${20/360 * 100}vw`,
				}}
			>
				<Button
					variant="outlined"
					sx={{
						bgcolor: optionMode === 'color' ? '#336cadff' : 'white',
						border: `${1/360 * 100}vw solid #6cadff`,
						borderRadius: `${15/360 * 100}vw`,
						width: `${74/360 * 100}vw`,
						height: `${30/360 * 100}vw`,
						marginRight: `${8/360 * 100}vw`,
					}}
					onClick={e => setOptionMode(optionMode === 'color' ? undefined : 'color')}
				>
					<Typography
						fontFamily='노토산스 Bold'
						fontSize={`${btnFontSize/360 * 100}vw`}
						color={optionMode === 'color' ? 'white' : '#6cadff'}
						sx={{margin:`${btnTextMargin}px`}}
					>
						배경색상
					</Typography>
				</Button>
				<Button
					variant="outlined"
					sx={{
						bgcolor: optionMode === 'scale' ? '#336cadff' : 'white',
						border: `${1/360 * 100}vw solid #6cadff`,
						borderRadius: `${15/360 * 100}vw`,
						width: `${74/360 * 100}vw`,
						height: `${30/360 * 100}vw`,
						marginRight: `${8/360 * 100}vw`,
					}}
					onClick={e => setOptionMode(optionMode === 'scale' ? undefined : 'scale')}
				>
					<Typography
						fontFamily='노토산스 Bold'
						fontSize={`${btnFontSize/360 * 100}vw`}
						color={optionMode === 'scale' ? 'white' : '#6cadff'}
						sx={{margin:`${btnTextMargin}px`}}
					>
						사이즈
					</Typography>
				</Button>
				<Button
					variant="outlined"
					sx={{
						bgcolor: optionMode === 'translationX' ? '#336cadff' : 'white',
						border: `${1/360 * 100}vw solid #6cadff`,
						borderRadius: `${15/360 * 100}vw`,
						width: `${74/360 * 100}vw`,
						height: `${30/360 * 100}vw`,
						marginRight: `${8/360 * 100}vw`,
					}}
					onClick={e => setOptionMode(optionMode === 'translationX' ? undefined : 'translationX')}
				>
					<Typography
						fontFamily='노토산스 Bold'
						fontSize={`${btnFontSize/360 * 100}vw`}
						color={optionMode === 'translationX' ? 'white' : '#6cadff'}
						sx={{margin:`${btnTextMargin}px`}}
					>
						좌우정렬
					</Typography>
				</Button>

				<input
					id={getSelectImageInputName()}
					type='file'
					accept='image/*'
					hidden
					onChange={handleImageSelect}
				/>
				<label htmlFor={getSelectImageInputName()}>
					<Button
						variant="contained"
						sx={{
							bgcolor: "#6cadff",
							border: `${1/360 * 100}vw solid #6cadff`,
							borderRadius: `${15/360 * 100}vw`,
							width: `${74/360 * 100}vw`,
							height: `${30/360 * 100}vw`,
						}}
						onClick={e => {
							setOptionMode(undefined);
							document.getElementById(getSelectImageInputName()).click()
						}}
					>
						<Typography
							fontFamily='노토산스 Bold'
							fontSize={`${btnFontSize/360 * 100}vw`}
							color='white'
							sx={{margin:`${btnTextMargin}px`}}
						>
							업로드
						</Typography>
					</Button>
				</label>
			</Box>
		);
	};

	const getOptionalSetting = () => {
		if (optionMode === 'color') {
			return (
				<ColorPallet curColorValue={backgroundColor} onUpdate={handleBackgroundColorChange}/>
			);
		}
		else if (optionMode === 'scale') {
			return (
				<ScaleBar value={scale * 100} onUpdate={handleScaleChange}/>
			);
		}
		else if (optionMode === 'translationX') {
			return (
				<ScaleBar value={(translationX / 2) + 50} onUpdate={handleTranslationXChange}/>
			);
		}
	};

	return (
		<Box
			display="flex"
			flexDirection="column"
			justifyContent="center"
			alignItems="center"
			sx={{
				left:`${20/360 * 100}vw`,
				width:`${320/360 * 100}vw`,
			}}
		>
			<BlockEditHeader
				blockName={block.name}
				iconChar={iconChar}
				iconColor={iconColor}
				onDelete={onDelete ? () => handleDelete() : undefined}
			/>
			{getImageArea()}
			{getButtons()}
			{getOptionalSetting()}
			{
				onDone && onCancel &&
				<BlockEditFooter
					onDone={e => handleDone()}
					onCancel={e => handleCancel()}
				/>
			}
		</Box>
	);
}

export default ImageBlockEditView;
